import React, { Fragment, useEffect, useState } from "react";
import Breadcrumb from "../common/breadcrumb";
import { Button, Card, CardBody, CardHeader, Col, Container, Row } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { DeleteCoupon, GetCoupon } from "../../redux/actions/productActions";
import DataTable from "react-data-table-component";
import SearchHeader from "../common/header_components/searchHeader";
import { toast } from "react-toastify";
import { RESET_ERROR } from "../../redux/constants/userConstants";
import AddCoupon from "./AddCoupon";
import moment from "moment";

const Coupons = () => {
    const dispatch = useDispatch();
    const { getcouponlist, coupondelsuccess, editedcoupon, newcoupon, error } = useSelector(state => state.product);
    const [datas, setDatas] = useState([]);
    const [open, setOpen] = useState(false);
    const [activeData, setActiveData] = useState(null);
    const [title, setTitle] = useState("");
    const [filterText, setFilterText] = useState("");

    const customToast = "delCoupon";
    const customCToast = "addCoupon";
    const customUToast = "editCoupon";

    const Capitalize = (str) => str.charAt(0).toUpperCase() + str.slice(1);

    const handleDelete = (id) => {
        if (window.confirm("Are you sure you wish to delete this coupon?")) {
            dispatch(DeleteCoupon(id));
        }
    };

    const handleEdit = (data) => {
        setTitle("Edit Coupon");
        setActiveData(data);
        setOpen(true);
    };

    const onOpenModal = () => {
        setTitle("Add Coupon");
        setActiveData(null);
        setOpen(true);
    };

    const onCloseModal = () => {
        setOpen(false);
    };

    useEffect(() => {
        dispatch(GetCoupon());
    }, []);

    useEffect(() => {
        if (getcouponlist) {
            setDatas(getcouponlist);
        }
    }, [getcouponlist]);

    useEffect(() => {
        if (coupondelsuccess) {
            toast.success("Coupon deleted successfully", { toastId: customToast });
            dispatch({ type: RESET_ERROR });
        }
    }, [coupondelsuccess]);

    useEffect(() => {
        if (newcoupon) {
            toast.success("Coupon created successfully", { toastId: customCToast });
            dispatch({ type: RESET_ERROR });
            setActiveData(null);
            setOpen(false);
            setTitle("");
        }
    }, [newcoupon]);

    useEffect(() => {
        if (editedcoupon) {
            toast.success("Coupon updated successfully", { toastId: customUToast });
            dispatch({ type: RESET_ERROR });
            setActiveData(null);
            setOpen(false);
            setTitle("");
        }
    }, [editedcoupon]);

    useEffect(() => {
        if (error) {
            toast.error(`${error.message}`);
            dispatch({ type: RESET_ERROR });
        }
    }, [error]);

    const columns = [
        {
            name: <b>{Capitalize("S.No")}</b>,
            header: <b>{Capitalize("S.No")}</b>,
            cell: (row, index) => index + 1
        },
        {
            name: <b>{Capitalize("Created Date")}</b>,
            header: <b>{Capitalize("Created Date")}</b>,
            selector: row => moment(row?.created_at).format('DD-MM-YYYY'),
            style: { textAlign: "center" },
        },
        {
            name: <b>{Capitalize("Coupon Code")}</b>,
            header: <b>{Capitalize("Coupon Code")}</b>,
            selector: row => row?.coupon_code,
            style: { textAlign: "center" },
        },
        {
            name: <b>{Capitalize("Discount Type")}</b>,
            header: <b>{Capitalize("Discount Type")}</b>,
            selector: row => row?.discount_type,
            style: { textAlign: "center" },
        },
        {
            name: <b>{Capitalize("Discount Value")}</b>,
            header: <b>{Capitalize("Discount Value")}</b>,
            selector: row => row?.discount_value,
            style: { textAlign: "center" },
        },
        {
            name: <b>{Capitalize("Start Date")}</b>,
            header: <b>{Capitalize("Start Date")}</b>,
            selector: row => moment(row?.start_date).format('DD-MM-YYYY'),
            style: { textAlign: "center" },
        },
        {
            name: <b>{Capitalize("End Date")}</b>,
            header: <b>{Capitalize("End Date")}</b>,
            selector: row => moment(row?.end_date).format('DD-MM-YYYY'),
            style: { textAlign: "center" },
        },
        {
            name: <b>Actions</b>,
            id: "actions",
            cell: (row) => (
                <>
                    <span onClick={() => handleDelete(row._id)}>
                        <i
                            className="fa fa-trash"
                            style={{ width: 35, fontSize: 20, padding: 11, color: "#e4566e", cursor: "pointer" }}
                        ></i>
                    </span>
                    <span onClick={() => handleEdit(row)}>
                        <i
                            className="fa fa-pencil"
                            style={{ width: 35, fontSize: 20, padding: 11, color: "rgb(40, 167, 69)", cursor: "pointer" }}
                        ></i>
                    </span>
                </>
            )
        }
    ];

    useEffect(() => {
        const filtered = getcouponlist?.filter(coupon =>
            coupon?.coupon_code?.toLowerCase().includes(filterText?.toLowerCase())
        );
        setDatas(filtered);
    }, [filterText]);

    const subHeaderComponentMemo = React.useMemo(() => {
        const handleClear = () => {
            if (filterText) {
                setFilterText('');
            }
        };

        return (
            <div style={{ display: 'flex', justifyContent: 'flex-end', flex: 1 }}>
                <SearchHeader onFilter={e => setFilterText(e.target.value)} onClear={handleClear} filterText={filterText} />
            </div>
        );
    }, [filterText]);

    return (
        <Fragment>
            <Breadcrumb title="Coupons" parent="Coupons" />
            <Container fluid="true">
                <Row>
                    <Col sm="12">
                        <Card>
                            <CardHeader>
                                <h5>Coupons</h5>
                            </CardHeader>
                            <CardBody>
                                <div className="btn-popup pull-right">
                                    <Button
                                        type="button"
                                        color="secondary"
                                        onClick={onOpenModal}
                                        data-toggle="modal"
                                        data-original-title="test"
                                        data-target="#exampleModal"
                                    >
                                        Add Coupon
                                    </Button>
                                </div>
                                <div className="clearfix"></div>
                                <div id="basicScenario" className="product-physical">
                                    <DataTable
                                        pagination
                                        columns={columns}
                                        data={datas}
                                        fixedHeader
                                        subHeader
                                        subHeaderComponent={subHeaderComponentMemo}
                                    />
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
            <AddCoupon
                openModal={open}
                onCloseModal={() => {
                    setActiveData(null);
                    setOpen(false);
                }}
                data={activeData}
                setActiveData={setActiveData}
                title={title}
            />
        </Fragment>
    );
};

export default Coupons;

